// extracted by mini-css-extract-plugin
export var container = "_n1-0";
export var dotAnimation = "_n1-2";
export var dotsLoading = "_n1-1";